<template>
  <el-dialog
    :before-close="closeDialog"
    :visible.sync="show"
    title="Reubicar taxi"
    :z-index="1000000"
  >
    <el-row :gutter="10">
      <el-col :span="4">
        <WorkgroupCentralSelector
          v-model="wgSelector"
          :allow-select-workgroups="false"
          @change="loadStops"
        />
      </el-col>
      <el-col :span="6">
        <el-input v-model="taxiLicense" size="mini" placeholder="Introduce nº licencia" />
        <div v-if="showInvalidLicense" class="error-message">Licencia inválida</div>
      </el-col>
      <el-col :span="8">
        <el-select
          v-model="stopSelected"
          size="mini"
          :disabled="allStops.length < 1"
          placeholder="Selecciona Parada"
          width="100%"
        >
          <el-option
            v-for="item in allStops"
            :key="item.id"
            :label="`(${centralNameById(item.idCentral)}) ${item.name}`"
            :value="item.id"
          />
        </el-select>
      </el-col>

      <el-col :span="4" class="text-center">
        <el-input-number
          v-model="position"
          size="mini"
          :min="1"
          placeholder="Posición"
          style="width: 100% !important"
        />
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="closeDialog">Cancelar</el-button>
      <el-button size="mini" type="primary" @click="relocate">Reubicar</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import WorkgroupCentralSelector from "../common/forms/WorkgroupCentralSelector.vue";
import { getStops } from "@/api/operations/stops";
import { debounce } from "@/utils/timers";

export default {
  name: "ReubicarExpulsarDialog",

  components: { WorkgroupCentralSelector },

  data() {
    return {
      taxiId: this.$store.state.reubicarExpulsar.taxiId,
      taxiLicense: undefined,
      showInvalidLicense: false,
      position: undefined,
      stopSelected: undefined,
      taxi: undefined,
      wgSelector: undefined,
      stops: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters("app", ["taxis", "centrals", "defaultSelectedWorkgroupAndCentral"]),

    show() {
      return this.$store.state.reubicarExpulsar.show;
    },

    debouncedValidateLicense() {
      return debounce(this.validateLicense, 500);
    },

    allStops() {
      let orderStops = [];
      if (this.stops) {
        orderStops = this.stops.flat();
        orderStops
          .sort(function (a, b) {
            if (a.ref < b.ref) {
              return -1;
            }
            if (a.ref > b.ref) {
              return 1;
            }
            return 0;
          })
          .sort(function (a, b) {
            if (a.idCentral < b.idCentral) {
              return -1;
            }
            if (a.idCentral > b.idCentral) {
              return 1;
            }
            return 0;
          });
      }
      return orderStops;
    },
  },

  watch: {
    async show(active) {
      if (active) {
        this.wgSelector = this.defaultSelectedWorkgroupAndCentral;
        this.loadStops();
      }
    },
    taxiLicense() {
      this.debouncedValidateLicense();
    },
    wgSelector() {
      this.debouncedValidateLicense();
    },
  },

  methods: {
    ...mapActions("clientTaxis", ["relocateTaxi"]),
    ...mapActions("clientStops", ["getStops"]),

    validateLicense() {
      this.showInvalidLicense = false;
      this.taxi = undefined;
      if (!this.taxiLicense) return;
      this.taxi = this.taxis.find(
        (t) => t.license === this.taxiLicense && t.idCentral === this.wgSelector[0].centralId
      );
      if (!this.taxi) {
        this.showInvalidLicense = true;
      }
    },

    centralNameById(id) {
      return this.centrals.find((c) => c.id === id)?.name;
    },

    async loadStops() {
      const stops = await getStops(this.wgSelector[0].wgId, this.wgSelector[0].centralId);
      this.stops = stops.filter((s) => !s.deleted);
    },

    async relocate() {
      if (this.stops && this.taxi) {
        const stop = this.allStops.find((stop) => stop.id === this.stopSelected);
        const payload = {
          params: {
            wgId: stop.idWorkgroup,
            centralId: stop.idCentral,
            taxiId: this.taxi.id,
          },
          data: {
            stopSelected: this.stopSelected,
            stopPosition: this.position,
          },
        };
        await this.relocateTaxi(payload);
        this.closeDialog();
      }
    },
    closeDialog() {
      this.taxiId = undefined;
      this.taxiLicense = undefined;
      this.position = undefined;
      this.stopSelected = undefined;
      this.$store.dispatch("reubicarExpulsar/showDialog", {
        show: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.error-message {
  color: #c03639;
  font-size: 11px;
  margin-top: 2px;
}
</style>
